import React from "react";
import { Box, Typography } from "@mui/material";
import parse from "html-react-parser";

/**
 * Sección de información de la incidencia (HTML formateado)
 */
const SeccionInformacion = ({ texto }) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        sx={{
          fontSize: { xs: 13, sm: 14 },
          color: "#495057",
          mb: 2,
        }}
      >
        {parse(texto)}
      </Typography>
    </Box>
  );
};

export default SeccionInformacion;
